import { APICore } from './apiCore'

const api = new APICore()

function getModulesInfotools (params) {
  const baseUrl = '/modules-infotools'
  return api.get(baseUrl, params)
}

function getModuleInfotools (key) {
  const baseUrl = `/modules-infotools/${key}`
  return api.get(baseUrl, {})
}

export { getModulesInfotools, getModuleInfotools }
